export const state = {
    transporters: [],
    systemTransporter: []
}
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/transporters/state.js